import React, { Component } from 'react'
import { Accordion } from 'react-accessible-accordion'
import moment from 'moment'

import { DATE_FORMAT_SQL } from '../../constants/constants'
import CertRow from './CertRow'

export default class History extends Component {
  render() {
    const  { assemblies } = this.props
    const history = []

    assemblies.forEach((assembly) => {
      const date = moment(assembly.date_end, DATE_FORMAT_SQL)

      if (date.isBefore((moment()))) {
        history.push({
          ...assembly,
          name: `Acta ${assembly.name}`,
        })
      }
    })

    if (!history.length) {
      return <p>Ahora mismo no hay ningún acta convocada.</p>
    }

    return (
      <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
        {history.map((cert) => <CertRow cert={cert} key={cert.id_witactas} />)}
      </Accordion>
    )
  }
}
